module.exports = __webpack_public_path__ + "img/pr-2.e501123c.png";